export enum ListingRelation {
  USER = 'user',
  STATE = 'state',
  COUNTY = 'county',
  MEDIA_DOCUMENTS = 'media_documents',
  MEDIA_MAPS = 'media_maps'
}
